<div class="file-chooser">

    <label for="accessToken">Access Token:</label>
    <input id="accessToken" type="text" [(ngModel)]="accessToken" />
    <br>
    <label for="accessTokenTTL">Access Token TTL:</label>
    <input id="accessTokenTTL" type="text" [(ngModel)]="accessTokenTTL" />
    <br>
    <label for="wopiSrc">Doc URL:</label>
    <input id="wopiSrc" type="text" [(ngModel)]="document.url" />
    <br>
    <select [(ngModel)]="document.product">
        <option *ngFor="let product of officeProducts" value="{{ product }}">{{
            product
            }}</option>
    </select>
    <button (click)="loadDocument()">
        Choose Document
    </button>
</div>

<form #officeForm id="officeForm" name="officeForm" target="officeFrame" method="post">
    <input name="access_token" [value]="accessToken" type="hidden" />
    <input name="access_token_ttl" [value]="accessTokenTTL" type="hidden" />
</form>

<span #officeFrameholder id="officeFrameholder"></span>